import { useEffect, useRef } from 'react';
import { useQuery } from '@tanstack/react-query';
import { GetPricesResponseData } from '@/api';
import { useOpenApi } from '@/common/providers/open-api-provider';

export function useFetchSubscriptionPrices(): {
    status: 'pending' | 'error' | 'success';
    data: GetPricesResponseData | undefined;
} {
    const { openApi } = useOpenApi();
    const openApiRef = useRef(openApi);
    useEffect(() => {
        openApiRef.current = openApi;
    });

    const { status, data } = useQuery({
        queryKey: ['fetchSubscriptionPrices'],
        queryFn: () =>
            openApiRef.current.subscriptions
                .getSubscriptionPrices()
                .then((response) => response.data.data)
    });

    return { status, data };
}
